
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm.118 3.985c-3.13 0-6.936 2.305-6.936 7.015 0 4.71 3.842 7.049 6.936 7.049 1.935 0 3.622-.693 5.061-2.079l-1.382-1.667c-1.022 1.077-2.248 1.615-3.68 1.615-2.146 0-4.66-1.666-4.66-4.881 0-3.215 2.525-4.948 4.543-4.948 2.018 0 3.125.953 3.658 1.49l.139.14 1.382-1.63c-1.355-1.402-3.043-2.104-5.061-2.104z","fill":"#F37723"}})])
          )
        }
      }
    